export { default } from './QuotesSection';



// WEBPACK FOOTER //
// ./src/components/templates/QuotesSection/index.js